import LoadingSpinner from "../../images/loading_gray.gif";
import Modal from "../Modal/Modal";
import { Container, MainButton } from "./CommentModalStyles";

function CommentModal(props) {
  const {
    waitingForServerResponse,
    toggleModal,
    title,
    message,
    onAccept,
    buttonText,
    disabled,
  } = props;

  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{title}</h1>
        <p style={{ overflowWrap: "break-word", width: "40rem" }}>{message}</p>
        <MainButton
          onClick={onAccept}
          disabled={waitingForServerResponse || disabled}
        >
          {waitingForServerResponse && (
            <img className="icon" src={LoadingSpinner} alt="spinner" />
          )}
          {buttonText || "Volver a subir documento"}
        </MainButton>
      </Container>
    </Modal>
  );
}

export default CommentModal;
